/* eslint-disable */
import cx from 'classnames';
import moment from 'moment';
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';


class TimeSlotsByDay extends Component {
  render() {
    if (!this.props.timeSlots) return null;

    let slots = this.props.timeSlots;
    slots.sort((a, b) => a.datetime.localeCompare(b.datetime));
    let byDay = {};
    for (let slot of slots) {
      let key = moment(slot.datetime).format('YYYY-MM-DD');
      if (!byDay[key]) {
        byDay[key] = [];
      }
      byDay[key].push(slot);
    }

    let days = Object.keys(byDay);
    days.sort();

    let dayNodes = days.map(day => {
      let timeSlotNodes = byDay[day].map(timeSlot => {
        return (
          <a href={timeSlot.bookUrl} target="_blank" key={timeSlot.id} className={cx('hour', timeSlot.status )}>
            {timeSlot.prettyHour}
          </a>
        );
      });

      let pretty;
      if (day == moment().format('YYYY-MM-DD')) {
        pretty = 'Today';
      } else if (day == moment().add(1, 'days').format('YYYY-MM-DD')) {
        pretty = 'Tomorrow';
      } else {
        pretty = moment(day, 'YYYY-MM-DD').format('ddd, MMM Do');
      }

      return (
        <div key={day} className="day-time-slots-wrapper">
          <div className="day">{pretty}</div>
          <div className="day-time-slots">{timeSlotNodes}</div>
        </div>
      )
    });

    return <div className="days">{dayNodes}</div>;
  }
}

export default TimeSlotsByDay;



/** WEBPACK FOOTER **
 ** ./src/components/partials/TimeSlotsByDay.js
 **/